import React, {Component} from "react";
import FooterComponent from "../components/FooterComponent";

export class Footer extends Component{
    render(){
        return(
            <FooterComponent />
        )
    }
}

export default Footer;